"use client";

import { useDisclosureStoreProps } from "./WYCIER3C.js";
import { useStore } from "./YV4JVR4I.js";

// src/dialog/dialog-store.ts
import * as Core from "@ariakit/core/dialog/dialog-store";
function useDialogStoreProps(store, update, props) {
  return useDisclosureStoreProps(store, update, props);
}
function useDialogStore() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [store, update] = useStore(Core.createDialogStore, props);
  return useDialogStoreProps(store, update, props);
}
export { useDialogStoreProps, useDialogStore };